export default {
    usuarios: [],
    usuario: {}
}